import { faCircleQuestion } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button, Content } from '@orobix/orobix-fe-components'
import { useContext, useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'

import useDriverStyle from '../../components/Driver/driver.styles'
import PageHeader from '../../components/PageHeader/PageHeader'
import { SettingsContext } from '../../components/Settings'
import useUpdateSettings from '../../components/Settings/useUpdateSettings'
import { useDispatch } from '../../store/store'
import { emptyProjects } from '../../store/storeActions'
import ButtonNewProject from './ButtonNewProject'
import getDriver from './Driver'
import ProjectsCreateUpdate from './ProjectsCreateUpdate'
import ProjectsList from './ProjectsList'
import useStyles from './ProjectsRoot.styles'

const ProjectsRoot = () => {
  const { t } = useTranslation()
  const classes = useStyles()
  const dispatch = useDispatch()
  const [projectsCreateUpdateModal, setProjectsCreateUpdateModal] = useState(
    false
  )
  const guidedTourShown = useRef(false)

  useEffect(
    () => () => {
      emptyProjects(dispatch)
    },
    [dispatch]
  )

  const { settings } = useContext(SettingsContext)
  const { updateSettings } = useUpdateSettings()

  const updatePreference = () => {
    const checkbox = document.getElementById(
      'doNotShowAgainCheckbox'
    ) as HTMLInputElement
    if (checkbox.checked === settings.preference__show_guided_tour) {
      updateSettings({
        preference__show_guided_tour: !checkbox.checked,
      })
    }
  }

  const classesDriver = useDriverStyle()
  const driverObj = getDriver(
    classesDriver,
    setProjectsCreateUpdateModal,
    settings,
    updateSettings,
    updatePreference,
    projectsCreateUpdateModal
  )

  useEffect(() => {
    if (guidedTourShown.current === false) {
      if (settings.preference__show_guided_tour && !driverObj.isActive()) {
        driverObj.drive()
        guidedTourShown.current = true
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [settings.preference__show_guided_tour])

  return (
    <Content>
      <PageHeader
        title={t('Projects')}
        right={
          <div>
            <div className={classes.flex}>
              <div id="newProjectButtonId" data-testid="newProjectButtonId">
                <ButtonNewProject
                  setProjectsCreateUpdateModal={setProjectsCreateUpdateModal}
                />
              </div>
              <Button
                label={t('Explain me how')}
                hideLabel
                icon={<FontAwesomeIcon icon={faCircleQuestion} size="lg" />}
                type="blank-default"
                onClick={() => {
                  driverObj.drive()
                }}
              />
            </div>
          </div>
        }
      />

      <ProjectsList />

      {projectsCreateUpdateModal && (
        <ProjectsCreateUpdate
          setModal={setProjectsCreateUpdateModal}
          type="create"
          driverObj={driverObj}
        />
      )}
    </Content>
  )
}

export default ProjectsRoot
